import script from "./SyncComparison.vue?vue&type=script&setup=true&lang=ts"
export * from "./SyncComparison.vue?vue&type=script&setup=true&lang=ts"

import "./SyncComparison.vue?vue&type=style&index=0&id=e1fff550&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1fff550"]])

export default __exports__